

<patient-jitsi-meeting [config]="config"> </patient-jitsi-meeting>
